import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { loadVariableStyles } from "./utils";
import { MsalProvider } from "@azure/msal-react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import { msalInstanceB2C } from "./authConfig";
import ToastDialog from "./components/common/ToastDialog";

loadVariableStyles();

const root = ReactDOM.createRoot(document.getElementById("root"));
const activeInstance = msalInstanceB2C;
root.render(
  <React.StrictMode>
    <MsalProvider instance={activeInstance}>
      <Provider store={store}>
        <BrowserRouter>
          <ToastDialog />
          <App />
        </BrowserRouter>
      </Provider>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
